import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Zones } from "@/models/database/zones/Zones.model";
import { Box, Flex, Theme } from "@radix-ui/themes";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import zoneProductImage from "branchAndBrandSpecific/utils/brandVariables/assets/logitech/logitech_ad_zone.webp";
import { SingleZoneCover } from "./SingleZoneCover";
import { SingleZoneFooter } from "./SingleZoneFooter";
import { SingleZoneNews } from "./SingleZoneNews";
import { SingleZoneEvents } from "./SingleZoneEvents";
import { SingleZoneChallenges } from "./SingleZoneChallenges";
import { SingleZoneProducts } from "./SingleZoneProducts";
import { SingleZoneStandings } from "./SingleZoneStandings";
import useSetClient from "@/hooks/useSetClient";

interface SingleZoneProps {
  data: Zones;
}

export const SingleZoneUi: FC<SingleZoneProps> = ({ data }): JSX.Element => {
  useDocumentTitle(data.title);
  useSetClient(data.slug);

  const theme = themeMap[data.theme.toUpperCase()] || "violet";
  const radius = themeRadiusMap[data.theme.toUpperCase()] || "none";

  return (
    <Box className="align-full">
      <Theme appearance="dark" accentColor={theme} radius={radius}>
        <Flex direction="column" gap="7">
          {/* Cover */}
          <SingleZoneCover {...data} />

          {/* Monthly standing */}
          <SingleZoneStandings zone={data} />

          {/* Product */}
          <SingleZoneProducts
            productImage={zoneProductImage}
            title={data.title}
          />

          {/* Challenges */}
          <SingleZoneChallenges zone={data} />

          {/* Events */}
          <SingleZoneEvents />

          {/* News */}
          <SingleZoneNews zone={data} />

          {/* Footer */}
          <SingleZoneFooter {...data} />
        </Flex>
      </Theme>
    </Box>
  );
};
